<template>
  <div>
    <el-row>
      <el-col :span="24" style="position: relative">
        <el-header class="index-header">
          <navcon></navcon>
        </el-header>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="云客户管理" name="dd">
            <cloudCustomers />
          </el-tab-pane>
          <!-- <el-tab-pane label="系统设置" name="week">

          </el-tab-pane>

          <el-tab-pane label="云数据库管理" name="cloudManage">
            <cloudManage />
          </el-tab-pane> -->

        </el-tabs>

      </el-col>
    </el-row>
  </div>
</template>
<script>
import cloudCustomers from "./cloudCustomers";
import cloudManage from "./cloudManage";
import navcon from "../../components/adminNavcon.vue";

export default {
  // 注册组件
  components: {
    cloudCustomers, // 云客户管理
    navcon,
    cloudManage, //云数据库管理
  },
  data() {
    return {
      activeName: "dd", //当前显示
      dateType: "dd", //参数值

    };
  },
  mounted() {
    // console.log(this.$store.state.adminLoginName)
  },
  methods: {
    handleClick(tab, event) {
    },


  },
};
</script>

<style lang="less" scoped>
.rightAllData {
  width: 55%;
  float: right;
  padding: 5px 0;
  overflow: hidden;

  .el-col {
    float: left;
  }

  label {
    font-size: 18px;
    margin: 0 3px;
  }
}

.table {
  width: 100%;
  border: 1px solid #ebeef5;
}

.table td {
  border: 1px solid #ebeef5;
  padding: 10px;
  width: auto;
  text-align: center;
}

.el-col-6 {
  width: 24%;
  float: right;

  .top {
    width: 100%;
    // height: 300px;
    margin-top: 0.05rem;

    div {
      overflow: hidden;
      margin-bottom: 10px;
    }

    span {
      float: left;
      font-size: 14px;
      display: inline-block;
      margin-top: 8px;
    }

    // 去掉表格单元格边框
    .customer-table th {
      border: none;
    }

    .customer-table td,
    .customer-table th.is-leaf {
      border: none;
    }

    .el-button {
      float: right;
    }
  }
}

.jumpSearch {
  position: absolute;
  top: 5px;
  left: 300px;
  z-index: 2;
}

/deep/ .el-header {
  height: 30px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/admin666/index.vue